<div class="scrollable-table">
  @if (loading) {
    <mat-progress-bar style="height: 5px; width: 100%;" mode="indeterminate"></mat-progress-bar>
  }

  <table mat-table [dataSource]="customers" class="mat-elevation-z8">
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef>First Name</th>
      <td mat-cell *matCellDef="let element">{{element.firstName}}</td>
    </ng-container>

    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef>Last Name</th>
      <td mat-cell *matCellDef="let element">{{element.lastName}}</td>
    </ng-container>

    <ng-container matColumnDef="primaryPhoneNumber">
      <th mat-header-cell *matHeaderCellDef>Primary Phone Number</th>
      <td mat-cell *matCellDef="let element">{{element.primaryPhoneNumber}}</td>
    </ng-container>

    <ng-container matColumnDef="secondaryPhoneNumber">
      <th mat-header-cell *matHeaderCellDef>Secondary Phone Number</th>
      <td mat-cell *matCellDef="let element">{{element.secondaryPhoneNumber}}</td>
    </ng-container>

    <ng-container matColumnDef="emailAddress">
      <th mat-header-cell *matHeaderCellDef>Email Address</th>
      <td mat-cell *matCellDef="let element">{{element.emailAddress}}</td>
    </ng-container>

    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef>Address</th>
      <td mat-cell *matCellDef="let element">{{element.address}}, {{element.city}}, {{element.state}} {{element.zipCode}}</td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        <button mat-icon-button
          matTooltip="Refresh"
          [disabled]="loading"
          (click)="getAllCustomers()"
          class="span-form margin-tb-10 float-right">
          <mat-icon>refresh</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>more_horiz</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="openACHDialog(element.userId)" mat-menu-item>
            <mat-icon>info</mat-icon>
            <span>ACH Data</span>
          </button>
          <button (click)="openCustomerApplicationDialog(element.userId)" mat-menu-item>
            <mat-icon>info</mat-icon>
            <span>Applications</span>
          </button>
          <button (click)="openCustomerHealthSurvey(element.userId)" mat-menu-item>
            <mat-icon>info</mat-icon>
            <span>Health Survey</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="customerColumnHeaders"></tr>
    <tr mat-row *matRowDef="let row; columns: customerColumnHeaders;"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No customers found.</td>
    </tr>
  </table>
</div>
